var exports = {
  "iE": "x127c5a35--f87266--wrapper",
  "kL": "x127c5a35--f87266--container",
};

module.exports = exports;
